import React from "react";

/*
 * Kuest tooltip: rounded-md border bg-background px-3 py-1.5 text-xs font-medium
 * shadow-xl, same fade/zoom as menus. Shows on hover (after a short delay) and on
 * keyboard focus; Esc hides it.
 */
export default function Tooltip({ content, side = "bottom", align = "center", delay = 300, className = "", children }) {
  const [open, setOpen] = React.useState(false);
  const timer = React.useRef(null);
  const id = React.useId();

  React.useEffect(() => () => clearTimeout(timer.current), []);
  if (!content) return children;

  const show = (immediate) => {
    clearTimeout(timer.current);
    if (immediate) setOpen(true);
    else timer.current = setTimeout(() => setOpen(true), delay);
  };
  const hide = () => {
    clearTimeout(timer.current);
    setOpen(false);
  };

  const pos =
    side === "top"
      ? "bottom-full mb-1.5"
      : side === "right"
      ? "left-full top-1/2 ml-1.5 -translate-y-1/2"
      : side === "left"
      ? "right-full top-1/2 mr-1.5 -translate-y-1/2"
      : "top-full mt-1.5";
  const horizontal = side === "top" || side === "bottom" ? (align === "end" ? "right-0" : align === "start" ? "left-0" : "left-1/2 -translate-x-1/2") : "";

  return (
    <span
      className="relative inline-flex"
      onPointerEnter={(e) => e.pointerType === "mouse" && show(false)}
      onPointerLeave={hide}
      onFocus={() => show(true)}
      onBlur={hide}
      onKeyDown={(e) => e.key === "Escape" && hide()}
      onMouseDown={hide}
      aria-describedby={open ? id : undefined}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          id={id}
          className={`wasaa-tooltip pointer-events-none absolute z-[90] w-max max-w-xs whitespace-normal rounded-md border border-border bg-background px-3 py-1.5 text-xs font-medium text-foreground shadow-xl ${pos} ${horizontal} ${className}`}
        >
          {content}
        </span>
      )}
    </span>
  );
}
